function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "35.528%",
  y1: "27.816%",
  x2: "85.889%",
  y2: "100%",
  id: "PLN_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "35.528%",
  y1: "27.816%",
  x2: "85.889%",
  y2: "100%",
  id: "PLN_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7208",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "41.692%",
  y1: "33.027%",
  x2: "80.518%",
  y2: "100%",
  id: "PLN_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "40.778%",
  y1: "27.816%",
  x2: "72.868%",
  y2: "100%",
  id: "PLN_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "29.837%",
  y1: "48.189%",
  x2: "100%",
  y2: "54.082%",
  id: "PLN_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.222 1.222)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#PLN_svg__a)",
  x: 10.236,
  y: 8.556,
  width: 9.319,
  height: 11,
  rx: 1.55
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.189 8.556h7.77v9.45a1.55 1.55 0 01-1.55 1.55h-6.22a1.55 1.55 0 01-1.55-1.55v-7.9c0-.856.694-1.55 1.55-1.55z",
  fill: "url(#PLN_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.55 0h12.178c.856 0 1.55.694 1.55 1.55v16.456a1.55 1.55 0 01-1.55 1.55H1.55A1.55 1.55 0 010 18.006V1.55C0 .694.694 0 1.55 0z",
  fill: "url(#PLN_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.462 5.004c.12.081.191.216.191.36v3.505l1.82.001a.434.434 0 01.36.677l-3.415 5.041a.434.434 0 01-.793-.243l-.001-3.508-1.82.001a.434.434 0 01-.359-.677L7.86 5.12a.434.434 0 01.602-.117z",
  fill: "url(#PLN_svg__d)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#PLN_svg__e)",
  x: 9.778,
  y: 2.292,
  width: 3.208,
  height: 1,
  rx: 0.465
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#PLN_svg__e)",
  x: 2.292,
  y: 16.347,
  width: 3.208,
  height: 1,
  rx: 0.465
}));

function SvgPln(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPln;